import api from './config';
import { ApiResponse } from '../types/api.types';

export interface DashboardStats {
  totalAssetCurrentValue: number;
  total: any;
  totalAssets: number;
  totalUsers: number;
  categoryWise: Array<{
    category: string;
    count: number;
  }>;
  expiringSoonCount: number;
  expiredAssets: number;
  assignedAssets: number;
  nonAssignedAssets: number;

}

export const dashboardApi = {
  getStats: async (params?: { fromDate?: string; toDate?: string }) =>
    await api.get<ApiResponse<DashboardStats>>('/api/dashboard/stats', { params }),
};